import React, { createRef, useContext, useState } from 'react'
import { AppContext } from '../context/AppContext';
import { CONFIG } from '../config/general';
import moment from 'moment';
import { toast } from 'react-toastify';
import { Cropper } from 'react-cropper';
import "cropperjs/dist/cropper.css";
import { updatePassword, updateProfile, uploadPicture } from '../services/companyServices';

const Settings = () => {
  const { login, setLogin } = useContext(AppContext);
  console.log(login.user)
  const cropperRef = createRef();
  const [newPassword, setNewPassword] = useState("");
  const [logoModal, setLogoModal] = useState(false);
  const [passwordModal, setPasswordModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [logo, setLogo] = useState(null)
  const [error, setError] = useState("");
  const [profileModal, setProfileModal] = useState(false);
  const [user, setUser] = useState(login.user)

  const handleChangePassword = async () => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    if (!currentPassword) {
      setError("Current password must be there.");
      return;
    }
    if (!regex.test(newPassword)) {
      setError("Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.");
      return;
    }
    if (currentPassword == newPassword) {
      setError("Current password and new password must not be same.");
      return;
    }
    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      let result = await updatePassword(login.token, { newPassword, confirmPassword, currentPassword })
      if (result.success) {
        toast.success(result.message)
        setNewPassword("")
        setCurrentPassword("")
        setConfirmPassword("")
        setPasswordModal(false)
      } else {
        toast.error(result.message)
      }
    } catch (error) {
      console.error("Error changing password:", error);
      setError("An error occurred. Please try again.");
    }
  };

  const handleLogoChange = (e) => {
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setLogo(reader.result)
    };
    reader.readAsDataURL(files[0]);
  };

  const onCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const cropBoxData = cropper.getCropBoxData();
      const cropWidth = cropBoxData.width;
      const cropHeight = cropBoxData.height;
      if (cropWidth < 100 || cropHeight < 100) {
        let newCropWidth = Math.max(cropWidth, 100);
        let newCropHeight = Math.max(cropHeight, 100);
        cropper.setCropBoxData({ width: newCropWidth, height: newCropHeight });
      }
    }
  };

  const uploadUpdatedPic = async (e) => {
    try {
      e.preventDefault();
      const formData = new FormData();
      const cropper = cropperRef.current?.cropper;
      if (cropper) {
        cropper.getCroppedCanvas().toBlob(async (blob) => {
          const croppedFile = new File([blob], "profile-pic.png", { type: "image/png" });
          formData.append(`picFile`, croppedFile);
          const result = await uploadPicture(login.token, formData)
          setLogo(null)
          if (result.success) {
            toast.success(result.message)
            setLogoModal(false)
          } else {
            toast.error(result.message)
          }
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleSaveProfile = async () => {
    try {
      const payload = user;

      // ✅ Basic validations
      if (!payload.name || payload.name.trim() === "") {
        toast.error("Name is required!");
        return;
      }

      if (!payload.email || payload.email.trim() === "") {
        toast.error("Email is required!");
        return;
      }

      // ✅ Email format check
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(payload.email)) {
        toast.error("Invalid email format!");
        return;
      }

      // ✅ Email domain validation (prevent user from changing domain)
      const originalDomain = login.user.email.split("@")[1];
      const newDomain = payload.email.split("@")[1];
      if (originalDomain !== newDomain) {
        toast.error(`Email domain must remain @${originalDomain}`);
        return;
      }

      if (payload.phone && !/^\d{10}$/.test(payload.phone)) {
        toast.error("Phone must be 10 digits!");
        return;
      }

      // ✅ Proceed with API call
      const result = await updateProfile(login.token, payload);

      if (result.success) {
        toast.success("Profile updated successfully!");

        // Update context user data
        setLogin((prev) => ({
          ...prev,
          user: {
            ...prev.user,
            ...payload,
          },
        }));

        setProfileModal(false);
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error("❌ Error updating profile:", err);
      toast.error("Failed to update profile.");
    }
  };


  const handleEmailChange = (e) => {
    const domain = user.email.substring(user.email.indexOf("@"));
    setUser({ ...user, email: e.target.value + domain });
  };

  return (
    <div className="details-table mt-3">
      <div className="container my-5">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8 col-sm-10">
            <div className="text-center mb-4">
              <div>
                <div>
                  <img
                    src={CONFIG.REACT_APP_UPLOADS + "/" + login.user.profilePicture}
                    className="img-thumbnail"
                    alt="Profile Picture"
                    width="150"
                    height="150"
                    id="profile-pic"
                  />
                </div>
                <div className='d-flex gap-2 justify-content-center'>
                  <div className="text-center">
                    <button
                      className="btn btn-success mt-3"
                      onClick={() => setLogoModal(true)}
                    >
                      Upload Profile Picture
                    </button>
                  </div>
                  <div className="text-center">
                    <button
                      className="btn btn-danger mt-3"
                      onClick={() => setPasswordModal(true)}
                    >
                      Change Password
                    </button>
                  </div>
                  <div className="text-center">
                    <button
                      className="btn btn-info mt-3"
                      onClick={() => setProfileModal(true)}
                    >
                      Edit Profile
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header">
                <h5>Company Details</h5>
              </div>
              <div className="card-body">
                <p><strong>Company Name:</strong> {login.user?.name}</p>
                <p><strong>Company Address:</strong> {login.user?.address}</p>
                <p><strong>Company Email:</strong> {login.user?.email}</p>
                <p><strong>Plan Type:</strong> {login?.user?.appPlanType}</p>
                <p><strong>Expiry Date:</strong> {moment(login.user?.appExpiringAt).format("DD-MMM-YYYY")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {logoModal && <div
        className="modal d-block show"
        id="uploadLogo"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="uploadLogoLabel">
                Upload Logo
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setLogoModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              <form id="logoUploadForm" onSubmit={uploadUpdatedPic}>
                <div className="mb-3">
                  <label htmlFor="logoFile" className="form-label">
                    Upload Logo
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="logoFile"
                    accept="image/*"
                    onChange={handleLogoChange}
                    required
                  />
                  {logo && <div style={{ width: '100%', height: '300px' }}>
                    <Cropper
                      ref={cropperRef}
                      src={logo}
                      aspectRatio={1}
                      style={{ width: '100%', height: '100%' }}
                      initialAspectRatio={1}
                      viewMode={1}
                      crop={onCrop}
                      minCropBoxWidth={100}
                      minCropBoxHeight={100}
                      background={false}
                      responsive={true}
                      autoCropArea={1}
                      checkOrientation={false}
                      guides={true}
                    />
                    <div className="img-preview"></div>
                  </div>}
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => setLogoModal(false)}
              >
                Close
              </button>
              <button
                type="submit"
                form="logoUploadForm"
                className="btn btn-primary"
                style={{ backgroundColor: '#1edd60', border: "none" }}
              >
                Upload
              </button>
            </div>
          </div>
        </div>
      </div>}
      {passwordModal && <div
        className="modal d-block show"
        id="changePasswordModal"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="changePasswordModalLabel">
                Change Password
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setPasswordModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label htmlFor="currentPassword" className="form-label">
                  Current Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="currentPassword"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="newPassword" className="form-label">
                  New Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="confirmPassword" className="form-label">
                  Confirm Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
              {error && <p className="text-danger">{error}</p>}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setPasswordModal(false)}
                id="closeChangePasswordModal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                style={{ backgroundColor: '#1edd60', border: "none" }}
                onClick={handleChangePassword}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>}
      {profileModal && (
        <div className="modal d-block show">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Profile</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setProfileModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3 d-flex gap-3 align-items-center">
                  <label className="form-label">Company Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={user.name}
                    onChange={(e) => setUser({ ...user, name: e.target.value })}
                  />
                </div>
                <div className="mb-3 d-flex gap-3 align-items-center">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={user.email.split("@")[0]}
                    onChange={handleEmailChange}
                  />
                  <span className="input-group-text">@{user.email.split("@")[1]}</span>
                </div>
                <div className="mb-3 ">
                  <label className="form-label">Address</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={user.address}
                    onChange={(e) => setUser({ ...user, address: e.target.value })}
                  ></textarea>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setProfileModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  style={{ backgroundColor: "#1edd60", border: "none" }}
                  onClick={handleSaveProfile}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  )
}

export default Settings
